const menu = [
  {
    id: 1,
    title: 'birthday reminder',
    category: 'basic projects',
    img: './images/birthday-reminder.png',
    tech: 'react',
    url: 'https://shikulja-react-birthday-reminder.netlify.app',
  },
  {
    id: 2,
    title: 'tours',
    category: 'basic projects',
    img: './images/tours.png',
    tech: 'react',
    url: 'https://shikulja-react-tour.netlify.app',
  },
  {
    id: 3,
    title: 'reviews',
    category: 'basic projects',
    img: './images/reviews.png',
    tech: 'react',
    url: 'https://shikulja-react-reviews.netlify.app',
  },
  {
    id: 4,
    title: 'accordion',
    category: 'basic projects',
    img: './images/accordion.png',
    tech: 'react',
    url: 'https://shikulja-react-accordion.netlify.app',
  },
  {
    id: 5,
    title: 'menu',
    category: 'basic projects',
    img: './images/menu.png',
    tech: 'react',
    url: 'https://shikulja-react-menu.netlify.app',
  },
  {
    id: 6,
    title: 'tabs',
    category: 'basic projects',
    img: './images/tabs.png',
    tech: 'react',
    url: 'https://shikulja-react-tabs.netlify.app',
  },
  {
    id: 7,
    title: 'slider',
    category: 'basic projects',
    img: './images/slider.png',
    tech: 'react',
    url: 'https://shikulja-react-slider.netlify.app',
  },
  {
    id: 8,
    title: 'lorem ipsum generator',
    category: 'basic projects',
    img: './images/lorem-ipsum.png',
    tech: 'react',
    url: 'https://shikulja-react-lorem-ipsum.netlify.app',
  },
  {
    id: 9,
    title: 'color generator',
    category: 'basic projects',
    img: './images/color-generator.png',
    tech: 'react',
    url: 'https://shikulja-react-color-generator.netlify.app',
  },
  {
    id: 10,
    title: 'grocery bud',
    category: 'basic projects',
    img: './images/grocery-bud.png',
    tech: 'react',
    url: 'https://shikulja-react-grocery-bud.netlify.app',
  },
  {
    id: 11,
    title: 'navbar',
    category: 'basic projects',
    img: './images/navbar.png',
    tech: 'react',
    url: 'https://shikulja-react-navbar.netlify.app',
  },
  {
    id: 12,
    title: 'sidebar and model',
    category: 'basic projects',
    img: './images/sidebar-modal.png',
    tech: 'react',
    url: 'https://shikulja-react-sidebar-modal.netlify.app',
  },
  {
    id: 13,
    title: 'stripe submenu',
    category: 'basic projects',
    img: './images/stripe-submenu.png',
    tech: 'react',
    url: 'https://shikulja-react-stripe-submenu.netlify.app',
  },
  {
    id: 14,
    title: 'cart',
    category: 'basic projects',
    img: './images/cart.png',
    tech: 'react',
    url: 'https://shikulja-react-cart.netlify.app',
  },
  {
    id: 15,
    title: 'cocktails DB',
    category: 'basic projects',
    img: './images/cocktails.png',
    tech: 'react',
    url: 'https://shikulja-react-cocktail.netlify.app/',
  },
  {
    id: 16,
    title: 'markdown preview',
    category: 'course exclusive',
    img: './images/markdown-preview.png',
    tech: 'react',
    url: 'https://shikulja-react-markdown-preview.netlify.app',
  },
  {
    id: 17,
    title: 'random person',
    category: 'course exclusive',
    img: './images/random-person.png',
    tech: 'react',
    url: 'https://shikulja-react-random-person.netlify.app',
  },
  {
    id: 18,
    title: 'pagination',
    category: 'course exclusive',
    img: './images/pagination.png',
    tech: 'react',
    url: 'https://shikulja-react-pagination.netlify.app',
  },
  {
    id: 19,
    title: 'stock photos',
    category: 'course exclusive',
    img: './images/stock-photos.png',
    tech: 'react',
    url: 'https://shikulja-react-stock-photos.netlify.app',
  },
  {
    id: 20,
    title: 'toggle dark/light mode',
    category: 'course exclusive',
    img: './images/dark-mode.png',
    tech: 'react',
    url: 'https://shikulja-react-dark-mode.netlify.app',
  },
  {
    id: 21,
    title: 'movies DB',
    category: 'course exclusive',
    img: './images/movie-db.png',
    tech: 'react',
    url: 'https://shikulja-react-movie-db.netlify.app',
  },
  {
    id: 22,
    title: 'hacker news',
    category: 'course exclusive',
    img: './images/hackers-news.png',
    tech: 'react',
    url: 'https://shikulja-react-hacker-news.netlify.app',
  },
  {
    id: 23,
    title: 'quiz',
    category: 'course exclusive',
    img: './images/quiz.png',
    tech: 'react',
    url: 'https://shikulja-react-quiz.netlify.app',
  },
  {
    id: 24,
    title: 'github users',
    category: 'large-scale projects',
    img: './images/github-users.png',
    tech: 'react',
    url: 'https://shikulja-react-search-github-users.netlify.app',
  },
  {
    id: 25,
    title: 'e-commerce',
    category: 'large-scale projects',
    img: './images/comfy-sloth.png',
    tech: 'react',
    url: 'https://shikulja-react-comfy-sloth-store.netlify.app',
  },
  {
    id: 26,
    title: 'jobster',
    category: 'large-scale projects',
    img: './images/jobster.png',
    tech: 'react-redux-toolkit',
    url: 'https://shikulja-redux-toolkit-jobster.netlify.app',
  },
  {
    id: 27,
    title: 'expenses',
    category: 'large-scale projects',
    img: './images/expenses.png',
    tech: 'remix-run-fullstack-app',
    url: 'https://shikulja-remix-expenses.netlify.app/',
  },
    {
    id: 28,
    title: 'mymoney',
    category: 'large-scale projects',
    img: './images/mymoney.png',
    tech: 'react-firebase-fullstack-app',
    url: 'https://mymoney-shikulja.web.app/',
  },
  {
    id: 29,
    title: 'invoice',
    category: 'large-scale projects',
    img: './images/invoice-app.png',
    tech: 'redux-toolkit-typescript',
    url: 'https://shikulja-invoice-app.netlify.app/',
  }
];
export default menu;
